import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";

const getClientConfigFileName = () => {
  const client = process.env.REACT_APP_CLIENT_NAME;

  switch (client) {
    case "ATOBABA":
      return 'atobaba.config.js';
    case "TELESOM":
      return 'telesom.config.js';
    default:
      throw new Error(`Unknown client: ${client}`);
  }
};

const loadConfig = () => {
  return new Promise<void>((resolve, reject) => {
    const clientConfigFileName = getClientConfigFileName();

    const script = document.createElement('script');
    script.src = `${process.env.PUBLIC_URL}/client-configs/${clientConfigFileName}`;
    script.async = false; // ensures it's loaded before app runs
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load client related config.js'));
    document.head.appendChild(script);

    /*todo: */
    const script2 = document.createElement('script');
    script2.src = `${process.env.PUBLIC_URL}/applyTheme.js`;
    script2.async = false; // ensures it's loaded before app runs
    script2.onload = () => resolve();
    script2.onerror = () => reject(new Error('Failed to load client related config.js'));
    document.head.appendChild(script2);
  });
};

// Load config first, then start the React app
loadConfig()
  .then(async () => {
    console.log('Config loaded:', (window as any).globalConfig);

    // Import modules that depend on the config
    const { default: App } = await import("./App");
    const { default: store } = await import("./storage");
    const { default: i18n } = await import("./util/i18n");
    const { I18nextProvider } = await import("react-i18next");
    const { Provider } = await import("react-redux");

    // Render React app
    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement
    );
    root.render(
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </Provider>
    );

    reportWebVitals();
  })
  .catch((err) => {
    console.error(err);
  });
